var _path, _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 36,
    viewBox: "0 0 37 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.5044 19.0778C29.0133 18.5689 29.0133 17.7436 28.5044 17.2347L20.2102 8.94047C19.7012 8.4315 18.876 8.4315 18.367 8.94047C17.858 9.44944 17.858 10.2747 18.367 10.7836L25.7396 18.1562L18.367 25.5289C17.858 26.0378 17.858 26.8631 18.367 27.372C18.876 27.881 19.7012 27.881 20.2102 27.372L28.5044 19.0778ZM8.68481 19.4596H27.5828V16.8529H8.68481V19.4596Z",
    fill: "#FF813B"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18.4595,
    cy: 18.1562,
    r: 17.2688,
    stroke: "#FF813B",
    strokeWidth: 0.651654
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.d19d0c4d7f2f0615b5c498896867a09e.svg";
export { ForwardRef as ReactComponent };